import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";


export default function PlayToolbarAvatar({ letter, color, size = 30, backgroundOpacity = 0.2, tooltipText = null, ...props }) {
  return (
    <div {...props}>
      <OverlayTrigger
        placement="bottom"
        overlay={tooltipText ? <Tooltip>{tooltipText}</Tooltip> : <></>}
      >
        <div
          className="d-flex align-items-center justify-content-center p-0 position-relative"
          style={{
            width: size,
            height: size,
            border: `${size / 10}px solid ${color}`,
            borderRadius: size / 4,
            transform: "rotate(-10deg)",
            userSelect: "none",
            overflow: "hidden", // contain the pseudo background
          }}
        >
          {/* translucent background layer */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              backgroundColor: color,
              opacity: backgroundOpacity,
            }}
          />
          {/* letter (not affected by opacity) */}
          <div
            style={{
              fontSize: size * 0.5,
              color: color,
              fontWeight: "bold",
              transform: "rotate(10deg)",
              position: "relative", // keep above bg
            }}
          >
            {letter}
          </div>
        </div>
      </OverlayTrigger>
    </div>
  );
}
